export default __webpack_public_path__ + "static/media/girlDog.c40102e7.svg";